import { storage } from "./storage";

const HISTORY_KEY = "report_history";
const MAX_HISTORY_ITEMS = 50;

export const reportHistory = {
  getAll() {
    const history = storage.get(HISTORY_KEY) || [];
    return history.sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp));
  },

  get(id) {
    const history = this.getAll();
    return history.find((item) => item.id === id);
  },

  add(report) {
    const history = this.getAll();
    const newReport = {
      ...report,
      timestamp: new Date().toISOString(),
    };

    const existingIndex = history.findIndex((item) => item.id === report.id);
    if (existingIndex !== -1) {
      history[existingIndex] = newReport;
    } else {
      history.unshift(newReport);
    }

    const trimmedHistory = history.slice(0, MAX_HISTORY_ITEMS);
    storage.set(HISTORY_KEY, trimmedHistory);
    return newReport;
  },

  update(id, updates) {
    const history = this.getAll();
    const index = history.findIndex((item) => item.id === id);

    if (index === -1) {
      return null;
    }

    history[index] = {
      ...history[index],
      ...updates,
      lastUpdated: new Date().toISOString(),
    };

    storage.set(HISTORY_KEY, history);
    return history[index];
  },

  remove(id) {
    const history = this.getAll();
    const filtered = history.filter((item) => item.id !== id);
    storage.set(HISTORY_KEY, filtered);
    return filtered.length < history.length;
  },

  clear() {
    return storage.remove(HISTORY_KEY);
  },
};
